import type FinancialInstitutionModel from './financial-institution';
import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class FinancialInstitutionPattern extends Model {
  @attr declare pattern: string;
  @attr declare docTypes: string[];
  @attr declare observableDocumentsCount: number;
  @attr declare ignored: boolean;

  @belongsTo('financial-institution', { async: false, inverse: null })
  declare financialInstitution: FinancialInstitutionModel;

  [Type] = 'financial-institution-pattern' as const;
}
